/**
 * ステージをまたぐ小さな記録（トロフィー・財布）の読み書き。
 *
 * StorageSystem と同じく、localStorage が使えない・壊れている場合でも落ちない。
 * そのときはメモリ上だけで動く（アプリを閉じると消える）。
 */

import { detectStorage, type StorageLike } from '../game/systems/StorageSystem';

export class JsonStore<T> {
  private readonly storage: StorageLike | null;
  private value: T;

  constructor(
    private readonly key: string,
    private readonly normalize: (raw: unknown) => T,
    storage?: StorageLike | null,
  ) {
    this.storage = storage !== undefined ? storage : detectStorage();
    this.value = this.read();
  }

  get data(): T {
    return this.value;
  }

  update(mutate: (draft: T) => void): T {
    mutate(this.value);
    this.write();
    return this.value;
  }

  private read(): T {
    try {
      const raw = this.storage?.getItem(this.key);
      return this.normalize(raw ? JSON.parse(raw) : null);
    } catch {
      return this.normalize(null);
    }
  }

  private write(): void {
    try {
      this.storage?.setItem(this.key, JSON.stringify(this.value));
    } catch {
      // 容量超過など。メモリ上の値はそのまま使う
    }
  }
}
